import { Typography } from '@montugroup/design-system';
import type { SxProps } from '@mui/material';
import { Box } from '@mui/material';
import type { ReactNode } from 'react';

export type SectionHeaderProps = {
  sx?: SxProps;
  headerText?: ReactNode;
  headingVariant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  actionButton?: ReactNode;
};

export const SectionHeader = ({ sx, headerText, actionButton, headingVariant = 'h6' }: SectionHeaderProps) => {
  return (
    <Box
      component="header"
      display="flex"
      width="100%"
      justifyContent="space-between"
      alignItems="center"
      sx={{ borderBottom: `1px solid`, borderColor: 'primary.light', ...sx }}
    >
      <Typography component="h2" variant={headingVariant} color="primary" sx={{ fontWeight: 600 }}>
        {headerText}
      </Typography>
      {actionButton}
    </Box>
  );
};
